/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StreamingResponseBody
 */
export interface StreamingResponseBody {
    /**
     * 
     * @type {Blob}
     * @memberof StreamingResponseBody
     */
    raw?: Blob;
}

/**
 * Check if a given object implements the StreamingResponseBody interface.
 */
export function instanceOfStreamingResponseBody(value: object): value is StreamingResponseBody {
    return true;
}

export function StreamingResponseBodyFromJSON(json: any): StreamingResponseBody {
    return StreamingResponseBodyFromJSONTyped(json, false);
}

export function StreamingResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreamingResponseBody {
    if (json == null) {
        return json;
    }
    return {
        
        'raw': json['raw'] == null ? undefined : json['raw'],
    };
}

export function StreamingResponseBodyToJSON(json: any): StreamingResponseBody {
    return StreamingResponseBodyToJSONTyped(json, false);
}

export function StreamingResponseBodyToJSONTyped(value?: StreamingResponseBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'raw': value['raw'],
    };
}

